import { SHARE_RESET } from '../../../../Share/constants'
import { RESET_WIZARD } from '../constants'

import { CHANGE_TEST_SCENARIOS, FETCH_TEST_CAMPAIGN_RESULTS_ASYNC, SET_ERROR } from './constants'

export default function () {
  const initialState = {
    loader: false,
    error: null,
    testResults: {
      data: [],
      loader: false,
    },
    testSelectedScenarios: [],
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case CHANGE_TEST_SCENARIOS:
        return {
          ...state,
          testSelectedScenarios: action.payload.selectedScenarios,
        }
      case SHARE_RESET:
        return {
          ...state,
          testSelectedScenarios: [],
        }

      case FETCH_TEST_CAMPAIGN_RESULTS_ASYNC.INITIATE:
        return {
          ...state,
          testResults: {
            ...state.testResults,
            loader: true,
          },
        }
      case FETCH_TEST_CAMPAIGN_RESULTS_ASYNC.SUCCESS:
        return {
          ...state,
          testResults: {
            ...state.testResults,
            loader: false,
            data: action.payload,
          },
        }
      case RESET_WIZARD:
        return {
          ...initialState,
        }
      case SET_ERROR:
        return {
          ...state,
          error: action.payload.value,
        }
      default:
        return state
    }
  }
}
